import { Monogram } from "./Monogram";
import { useScrollTo } from "@/lib/useScrollTo";
import { useLang } from "@/lib/i18n";
import { Link } from "react-router-dom";

export const Footer = () => {
  const scrollTo = useScrollTo();
  const { copy } = useLang();
  return (
    <footer data-testid="site-footer" className="bg-plum text-cream border-t border-cream/10">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-14 md:py-20">
        <div className="flex flex-col lg:flex-row justify-between gap-16">
          <div>
            <div className="flex items-center gap-4 text-cream">
              <Monogram className="h-12 w-auto" variant="cream" />
              <span className="font-serif text-xl tracking-[0.18em] uppercase">
                House <span className="italic normal-case tracking-normal">of</span> Alvirah
              </span>
            </div>
            <p className="mt-8 text-sm font-light text-cream/50 max-w-xs leading-relaxed">
              {copy.footer.tagline}
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 gap-12">
            <div>
              <p className="text-[10px] uppercase tracking-[0.35em] text-cream/60 mb-6">{copy.footer.explore}</p>
              <div className="flex flex-col gap-3">
                {copy.footer.links.map(({ label, target }) => (
                  <button
                    key={target}
                    data-testid={`footer-link-${target.slice(1)}`}
                    onClick={() => scrollTo(target)}
                    className="text-start text-sm font-light text-cream/70 hover:text-cream transition-colors duration-300"
                  >
                    {label}
                  </button>
                ))}
              </div>
            </div>
            <div>
              <p className="text-[10px] uppercase tracking-[0.35em] text-cream/60 mb-6">{copy.footer.concierge}</p>
              <div className="flex flex-col gap-3 text-sm font-light text-cream/70">
                <span data-testid="footer-phone" dir="ltr">+971 4 000 0000</span>
                <span data-testid="footer-email">concierge@houseofalvirah.ae</span>
                <span data-testid="footer-instagram">@houseofalvirah</span>
              </div>
            </div>
            <div>
              <p className="text-[10px] uppercase tracking-[0.35em] text-cream/60 mb-6">{copy.footer.atelier}</p>
              <div className="flex flex-col gap-3 text-sm font-light text-cream/70">
                <span>{copy.footer.address1}</span>
                <span>{copy.footer.address2}</span>
                <span>{copy.footer.hours}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-cream/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-[10px] uppercase tracking-[0.3em] text-cream/40">{copy.footer.rights}</p>
          <Link to="/admin" data-testid="footer-admin-link" className="text-[10px] uppercase tracking-[0.3em] text-cream/40 hover:text-cream transition-colors duration-300">
            {copy.footer.admin}
          </Link>
        </div>
      </div>
    </footer>
  );
};
